<template>
  <div class="container">
    <div class="title">
      <img src="../../../static/image/userinfo/lion.png" v-if="imgPaths=='' || imgPaths == null" />
      <img :src="headPicture" alt v-else/>
      <div class="userName">{{userInfo.name==null?"":userInfo.name}}{{userInfo.designerCode==null?"":userInfo.designerCode}}</div>
      <div class="authentication" v-if="userInfo.auditStatus==0" @click="goAuth">审核不通过</div>
      <div class="authentication" v-if="userInfo.auditStatus==1" @click="goAuth">认证成功</div>
      <div class="authentication" v-if="userInfo.auditStatus==2" @click="goAuth">待审核</div>
      <div class="authentication" v-if="userInfo.auditStatus==3" @click="goAuth">去认证 </div>
      <div class="user1">LV{{userInfo.growthLevel}}</div>
      <div class="progressBar" v-if="userInfo.growthLevel!=4">
        <el-progress :percentage="percentage" color="#E0BB7D" :stroke-width="5" :format="format" style="width: 260px;"></el-progress>
      </div>
      <div class="progressBar" v-if="userInfo.growthLevel==4">
        <el-progress :percentage="100" color="#E0BB7D" :stroke-width="5" :format="format" style="width: 260px;"></el-progress>
      </div>
       <div class="user-text" v-if="userInfo.growthLevel!=4">再完成{{task}}%任务就可以升级啦</div>
      <div class="user-text" v-if="userInfo.growthLevel==4">您已经是LV4设计师啦</div>
    </div>

    <div class="other">
      <div class="other-title">
        <router-link to="/userInfo/userInfo" active-class="other-tit"  class="pad">个人信息</router-link>
      </div>
      <div class="other-title"  >
        <router-link to="/myprice/myprice" active-class="other-tit" class="pad">我的收入</router-link>
      </div>
      <div class="other-title" >
        <router-link to="/mycontract/mycontract" active-class="other-tit" class="pad">我的合同</router-link>
      </div>
      <div class="other-title" >
        <router-link to="/mypoints/mypoints" active-class="other-tit" class="pad">我的积分</router-link>
      </div>
      <div class="other-title" >
        <router-link to="/collection/collection" active-class="other-tit" class="pad">我的收藏</router-link>
      </div>
      <div class="other-title" >
        <router-link to="/myCoverWork/myCoverWork" active-class="other-tit" class="pad" v-if="userInfo.auditStatus==1">自荐作品</router-link>
        <p  v-else @click="noCover" class="pad">自荐作品</p>
      </div>
      <div class="other-title" >
        <router-link to="/feedback/feedback" active-class="other-tit" class="pad">我要反馈</router-link>
      </div>
      <div class="other-title" >
        <router-link to="/report/report" active-class="other-tit" class="pad">廉政投诉举报</router-link>
      </div>
     <div class="other-title" >
       <div to="/index"  class="pad" @click="contact()">联系我们</div>
     </div>

      <!-- 激活邮箱弹窗 -->
      <el-dialog title="" :visible.sync="isActivation" width="30%" :before-close="handleClose">
       <span>个人账号认证成功后，才可以自荐作品哦，是否去认证？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isActivation = false">取 消</el-button>
          <el-button @click="goActive">去认证</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import config from "../../api/config";
export default {
  name: "userNavigationBar",
  data() {
    return {
      isTrue:false,
      userInfo:{},  //用户信息
      percentage: undefined,//进度条
      imgPaths:'',   //后台头像地址
      total:'' ,//升级所需
      task:'' ,//还差多少
      baseImgUrl:config.baseImgUrl,   //拼接地址
      headPicture:'' ,//头像完整地址
      phone:'',
      isActivation:false,
    };
  },
  created() {
    // 获取存的用户信息
      this.getDetails();
      this.queryServiceMessage()
  },
  methods: {
    goActive(){  //去认证页面
      this.$router.push({path:"/userInfo/certiInfo"})
    },
    noCover(){
      // this.$message.warning("暂无自荐权限")
      this.isActivation = true
    },
    handleClose(){
      this.isActivation = false
    },
    contact(){   //联系我们弹窗
      this.$alert("联系电话："+this.phone, '联系我们', {
          confirmButtonText: '确定',
          callback: action => {
            console.log(action);
            // this.$message({
            //   type: 'info',
            //   message: `action: ${ action }`
            // });
          }
        });
    },
    async  queryServiceMessage(){   //获取客服电话
        try {
          const res = await this.$http.queryServiceMessage()
          console.log(res)
          if (res.code == 200) {
             this.phone = res.result[0].phone;
             console.log(this.phone)
          } else {
            // this.$message(res.message);
          }
        } catch (e) {

          throw e
        }
      },
    format(){   //进度条(不显示后边的百分比)
      return ''
    },
    goAuth(){
      this.$router.push({path:"/userInfo/certiInfo"})
    },
    async  getDetails(){   //获取保存数据
        console.log(11111)
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        try {
          const res = await this.$http.getDetails(userInfo.id)
          console.log(res)
          if (res.code == 200) {
              this.imgPaths = res.result.headPicture
              this.headPicture = this.imgPaths?this.imgPaths.indexOf('http')>-1? this.imgPaths:this.baseImgUrl+ this.imgPaths:"";
              this.percentage = parseInt(res.result.gradeValue/res.result.upgradeValue*100)
              this.total = res.result.upgradeValue
              this.task = parseInt((1-res.result.gradeValue/res.result.upgradeValue)*100)
              this.userInfo = res.result

              console.log(res.result.gradeValue,res.result.upgradeValue,this.total)
          } else {
            this.$message(res.message);
          }
        } catch (e) {

          throw e
        }
      },

  },
};
</script>


<style scoped>
.container {
  width: 100%;
  box-sizing: border-box;
}
.remove{
  border: none !important;
}
.pad{
  padding-left: 27px;
}
a {
  text-decoration: none;
  color: #3A3A3A;
  border-left: 2px solid #ffffff;
  cursor: pointer;
}

.router-link-active {
  text-decoration: none;
}
.title {
  width: 256px;
  height: 279px;
  box-sizing: border-box;
  background: #ffffff;
  /* width: 100%; */
  padding: 32px 18px 30px 20px;
  text-align: center;
}
.title img {
  width: 90px;
  height: 90px;
  border-radius: 50%;
}
.title-text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #3a3a3a;
  opacity: 1;
  margin: 38px 0 0 0;
}
.num {
}
.but {
  background: #ffffff;
  border: 1px solid #9e9e9e;
  opacity: 1;
  border-radius: 5px;
  padding: 0 24px;
}
.other {
  /* width: 100%; */
  height: 438px;
  background: #ffffff;
  padding: 1px 0px 1px 0px;
  margin: 21px 0 0 0;
  text-align: center;
  line-height: 30px;

}
.hr {
  border-bottom: solid 1px #c7c7c7;
  margin: 0 -24px 19px -24px;
}
.other>.other-title:nth-of-type(6){
    padding-bottom:18px;
    /* margin: 18px 0; */
    border-bottom: 1px solid #C7C7C7;
}
.other-title {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #3a3a3a;
  opacity: 1;
  margin: 15px 0;
  /* padding: 0 27px; */
  text-align: left;
  border-left: 2px solid #ffffff;
  cursor: pointer;
}
.other-tit{
    border-left: 2px solid #dfb876;
    color: #dfb876;
}
.other img {
  margin: 0 0 15px 0;
  width: 100%;
  height: 210px;
}
.userName {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 25px;
  color: #3a3a3a;
  margin-bottom: 12px;
}
.authentication {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 18px;
  color: #dfb876;
  opacity: 1;
  display: inline;
  border: 1px solid #dfb876;
  border-radius: 13px;
  padding: 4px 15px;

}
.user1 {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 17px;
  color: #3a3a3a;
  opacity: 1;
  margin: 7px 0 4px;
  text-align: left;
}
.progressBar {
  margin-left: -20px;
  margin-bottom: 14px;
 /* height: 5px;
  background: #e9e9e9;
  border-radius: 10px; */
}
.user-pro {
  height: 5px;
  background: #dfb876;
  border-radius: 10px;
}
.user-text {
  text-align: left;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 17px;
  color: #3a3a3a;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/userNavigationBar/userNavigationBar.vue